import FormattedMessage from 'I18n/components/FormattedMessage';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import { SchedulingSteps } from './constants';
import { getHardSavedContentModelIsPublishedNotScheduled, getHardSavedContentModelIsScheduled } from 'ContentEditorUI/redux/selectors/hardSavedContentModelSelectors';
import { useSelector } from 'react-redux';
import useContentCrmObject from '../../hooks/useContentCrmObject';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SchedulingTabs = ({
  tabType,
  handleTabChange,
  canScheduleUnpublish,
  currentStep,
  scheduledPublishDateTime
}) => {
  const isPublished = useSelector(getHardSavedContentModelIsPublishedNotScheduled);
  const isScheduled = useSelector(getHardSavedContentModelIsScheduled);
  const {
    isContentCrmObjectScheduled,
    isContentCrmObjectPublished
  } = useContentCrmObject();
  const isUnpublishTabEnabled = isContentCrmObjectScheduled || isScheduled || isContentCrmObjectPublished || isPublished || scheduledPublishDateTime;
  if (!canScheduleUnpublish) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UITabs, {
    selected: tabType,
    fill: true,
    use: "enclosed",
    onSelectedChange: ({
      target: {
        value
      }
    }) => handleTabChange(value),
    children: [/*#__PURE__*/_jsx(UITab, {
      tabId: "schedulePublish",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "baseSchedulingOptionsModal.tabs.schedulePublish"
      }),
      icon: currentStep.schedulePublish === SchedulingSteps.SCHEDULING ? 'success' : undefined
    }), /*#__PURE__*/_jsx(UITab, {
      tabId: "scheduleUnpublish",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "baseSchedulingOptionsModal.tabs.scheduleUnpublish"
      }),
      icon: currentStep.scheduleUnpublish === SchedulingSteps.SCHEDULING ? 'success' : undefined,
      disabled: !isUnpublishTabEnabled
    })]
  });
};
export default SchedulingTabs;